import { fabric } from 'fabric'
import React, { useEffect, useRef, useState } from 'react'
import ReactDOMServer from 'react-dom/server'
import lineArrowLeftRight from '../utils/lineArrowLeftRight'
import triangleDrawing from '../utils/triangleDrawing'
import LineShape from './../customObjects/LineShape'
//import copyPaste from './../utils/copyPaste'
import lineArrow from './../utils/lineArrow'
import lineArrowTwo from './../utils/lineArrowTwo'
import rectangleDrawing from './../utils/rectangleDrawing'

import lineDrawing from './../utils/lineDrawing'
import pathDrawing from './../utils/pathDrawing'
import textBoxDrawing from './../utils/textBoxDrawing'

import '../assets/css/FabricCanvas.scss'
import BlockLineShape from '../customObjects/BlockLineShape'
import LineArrowObject from '../customObjects/LineArrowObject'
import NarrowPointerShape from '../customObjects/NarrowPointerShape'
import CommentPopUp from '../modal/CommentPopUp'
import {
    BORDER_COLOR,
    CANVAS_HEIGHT,
    CANVAS_WIDTH,
    CORNER_COLOR,
    CORNER_STROKE_COLOR,
    CORNER_STYLE,
    TRANSPARENT_CORNERS
} from '../utils/constant'
import { getZoomRatio } from '../utils/customUtil'
import demoContent from '../utils/demoContent'

import TextboxObject from '../customObjects/TextBoxObject'
import circleDrawing from '../utils/circleDrawing'
import endCapsLine from '../utils/endCapsLine'
import rectangle3SidedDrawing from '../utils/rectangle3sided'
//import { pasteFromIndexedDB } from '../utils/testDB'
import { ReactComponent as IconDelete } from '../assets/icons/custom/delete.svg'
import { ReactComponent as RedoIcon } from '../assets/icons/redo.svg'
import { ReactComponent as UndoIcon } from '../assets/icons/undo.svg'
import Rectangle3Sided from '../customObjects/Rectangle3Sided'
import { applyZoom } from '../utils/zoom'
import CommentShape from './comments/CommentShape'
import markerDrawing from './comments/MarkerDrawing'

const FabricCanvas = (props) => {
    // console.log('Props:', props)
    const [newCanvas, setNewCanvas] = useState()
    const imageUploadRef = useRef([])
    const canvasNameRef = useRef('')
    const eventListenerRef = useRef()
    // const [pasteCounter, setPasteCounter] = useState(0)
    // const [pasteCounter1, setPasteCounter1] = useState(0)
    // const [pasteTrigger, setPasteTrigger] = useState(false)
    //   console.log('Window:', window)

    // const copyDataRef = useRef('')
    // useEffect(() => {
    //     copyDataRef.current = props.copyData
    // }, [props.copyData])

    // const handlePasteAction = useCallback(() => {
    //     setPasteTrigger(false)
    // }, [])

    // const handlePasteAction1 = useCallback((e) => {
    //     const key = e.which || e.keyCode
    //     if (key === 86) {
    //         setPasteTrigger(true)
    //     }
    // }, [])

    // useEffect(() => {
    //     document.addEventListener('keydown', handlePasteAction1)
    //     document.addEventListener('keyup', handlePasteAction)
    //     return () => document.removeEventListener('keydown', handlePasteAction1)
    // }, [handlePasteAction1])

    // useEffect(() => {
    //     // if (pasteTrigger && props.activeCanvasId === props.idName) {
    //     //     pasteFromIndexedDB(props.canvas, fabric)
    //     // }
    //         if( copyDataRef && copyDataRef.current && pasteTrigger && props.activeCanvasId === props.idName){
    //             let objects = copyDataRef.current.objects;
    //             setPasteTrigger(false);
    //             let fabricObjects = [];
    //             let loadedImages = 0;
    //             objects.forEach((obj) => {
    //                 createFabricObject(obj, function(fabricObj) {
    //                     fabricObjects.push(fabricObj);
    //                     // If the object is an image, increment the loaded images counter
    //                     if (obj.type === 'image') {
    //                         loadedImages++;
    //                     }
    //                     // Check if all images are loaded (or if there are no images)
    //                     if (fabricObjects.length === objects.length && (loadedImages === objects.filter(obj => obj.type === 'image').length)) {
    //                         let group = new fabric.Group(fabricObjects, {
    //                             left: copyDataRef.current.left,
    //                             top:  copyDataRef.current.top,
    //                             subTargetCheck: true,
    //                         });
    //                         // Add the group to the canvas
    //                         if(group){
    //                             props.canvas.add(group);
    //                             props.canvas.renderAll();
    //                         }
    //                     }
    //                 });
    //             });
    //     }
    // }, [pasteTrigger, setPasteTrigger, props.activeCanvasId, props.idName])

    // function createFabricObject(obj, callback) {
    //     if (obj.type === 'image') {
    //         // Handle image objects
    //         fabric.Image.fromURL(
    //             obj.src,
    //             function (img) {
    //                 // Apply properties to the image
    //                 img.set(obj)
    //                 callback(img)
    //             },
    //             { crossOrigin: 'anonymous' }
    //         )
    //     } else {
    //         // Handle other objects like polyline and line
    //         let fabricObject = null
    //         switch (obj.type) {
    //             case 'polyline':
    //                 fabricObject = new fabric.Polyline(obj.points, obj)
    //                 break
    //             case 'line':
    //                 fabricObject = new fabric.Line(obj.points, obj)
    //                 break
    //             // Add cases for other object types as needed
    //         }
    //         callback(fabricObject)
    //     }
    // }

    useEffect(() => {
        imageUploadRef.current = props.imageList
    }, [props.imageList])

    useEffect(() => {
        canvasNameRef.current = props.canvasTitle
    }, [props.canvasTitle])

    useEffect(() => {
        props.resetCanvas(undefined)
    }, [])

    useEffect(() => {
        TextboxObject(fabric)
        Rectangle3Sided(fabric)
    }, [fabric])
    // // init fabric canvas once
    useEffect(() => {
        // the code below runs only once
        const isCanvasExist = document.querySelector(`#parent_${props.idName}`)

        if (
            props.canvas ||
            (isCanvasExist &&
                isCanvasExist.querySelectorAll(`.canvas-container`).length > 0)
        ) {
            return
        }
        fabric.Object.prototype.objectCaching = false
        fabric.Object.prototype.statefullCache = false
        fabric.Object.prototype.noScaleCache = true

        let fabricObj = LineArrowObject(fabric)

        // create instance
        let fabricCanvas = new fabricObj.Canvas(props.idName, {
            preserveObjectStacking: true
        }).setDimensions({
            width: CANVAS_WIDTH,
            height: CANVAS_HEIGHT
        })

        if (props.listOfCanvasData[props.idName]) {
            fabricCanvas.loadFromJSON(
                props.listOfCanvasData[props.idName].canvasData
            )
        }
        fabricCanvas.uniScaleKey = ''
        fabricCanvas.freeDrawingBrush = new fabric.PencilBrush(fabricCanvas)
        fabricCanvas.freeDrawingBrush.width = 3
        fabricCanvas.freeDrawingBrush.color = props.drawColor
        fabricCanvas.freeDrawingBrush.drawStraightLine = true
        fabricCanvas.freeDrawingBrush.straightLineKey = 'shiftKey'
        fabricCanvas.originalW = fabricCanvas.width
        fabricCanvas.originalH = fabricCanvas.height

        // set up selection style
        fabricObj.Object.prototype.transparentCorners = TRANSPARENT_CORNERS
        fabricObj.Object.prototype.cornerStyle = CORNER_STYLE
        fabricObj.Object.prototype.borderColor = BORDER_COLOR
        fabricObj.Object.prototype.cornerColor = CORNER_COLOR
        fabricObj.Object.prototype.cornerStrokeColor = CORNER_STROKE_COLOR
        fabricObj.Object.prototype.padding = 0

        fabricCanvas.setBackgroundColor('#ffffff')
        fabricCanvas.on('object:moving', (e) => {
            if (fabricCanvas?.getActiveObject()?.type === 'CustomTextbox') {
                fabricCanvas.bringToFront(e.target)
            }
        })
        // retrieve active selection to react state
        fabricCanvas.on('selection:created', (e) =>
            props.setActiveSelection(e.selected)
        )
        fabricCanvas.on('selection:updated', (e) =>
            props.setActiveSelection(e.selected)
        )
        fabricCanvas.on('selection:cleared', (e) =>
            props.setActiveSelection(null)
        )

        // snap to an angle on rotate if shift key is down
        fabricCanvas.on('object:rotating', (e) => {
            if (e.e.shiftKey) {
                e.target.snapAngle = 15
            } else {
                e.target.snapAngle = false
            }
        })
        // keep objects within frame
        fabricCanvas.on('object:moving', (e) => {
            const obj = e.target

            // if object is too big ignore
            if (
                obj.currentHeight > obj.canvas.height ||
                obj.currentWidth > obj.canvas.width
            ) {
                return
            }

            // set offset for moving out the canvas (20px of object persists in canvas)
            const offsetWidth = obj.getBoundingRect().width - 20
            const offsetHeight = obj.getBoundingRect().height - 20

            obj.setCoords()

            // top-left corner
            if (
                obj.getBoundingRect().top < -offsetHeight ||
                obj.getBoundingRect().left < -offsetWidth
            ) {
                obj.top = Math.max(
                    obj.top,
                    obj.top - (obj.getBoundingRect().top + offsetHeight)
                )
                obj.left = Math.max(
                    obj.left,
                    obj.left - (obj.getBoundingRect().left + offsetWidth)
                )
            }

            // bot-right corner
            if (
                obj.getBoundingRect().top + obj.getBoundingRect().height >
                    obj.canvas.height + offsetHeight ||
                obj.getBoundingRect().left + obj.getBoundingRect().width >
                    obj.canvas.width + offsetWidth
            ) {
                obj.top = Math.min(
                    obj.top,
                    obj.canvas.height -
                        obj.getBoundingRect().height +
                        obj.top -
                        obj.getBoundingRect().top +
                        offsetHeight
                )
                obj.left = Math.min(
                    obj.left,
                    obj.canvas.width -
                        obj.getBoundingRect().width +
                        obj.left -
                        obj.getBoundingRect().left +
                        offsetWidth
                )
            }
        })

        const keyDownListener = (e) => {
            const key = e.which || e.keyCode
            let activeObject

            if (
                document.querySelectorAll('textarea:focus, input:focus')
                    .length > 0
            )
                return

            if (key === 37 || key === 38 || key === 39 || key === 40) {
                e.preventDefault()
                activeObject = fabricCanvas?.getActiveObject()
                if (!activeObject) {
                    return
                }
            }

            if (key === 37) {
                activeObject.left -= 1
            } else if (key === 39) {
                activeObject.left += 1
            } else if (key === 38) {
                activeObject.top -= 1
            } else if (key === 40) {
                activeObject.top += 1
            }

            if (key === 37 || key === 38 || key === 39 || key === 40) {
                activeObject.setCoords()
                fabricCanvas.requestRenderAll()
                fabricCanvas.calcOffset()
                fabricCanvas.fire('object:modified')
            }
        }

        // move objects with arrow keys
        document.addEventListener('keydown', keyDownListener)

        // deselect active object on outside click
        const deselectActiveObject = (e) => {
            if (e.target.id === 'app') {
                fabricCanvas?.discardActiveObject().requestRenderAll()
                fabricCanvas.calcOffset()
            }
        }

        document.addEventListener('mousedown', deselectActiveObject)
        document.addEventListener('touchstart', deselectActiveObject)

        // copy/paste
        // console.log('copyData-FabricCanvas:',  props.copyData)
        // copyPaste(
        //     fabricCanvas,
        //     fabric,
        //     props.copyArtBoardData,
        //     props.pasteArtBoardData
        //     // copyDataRef.current,
        //     //  handlePasteAction
        // )

        // delete object on del key
        document.addEventListener('keydown', (e) => {
            const key = e.which || e.keyCode
            if (
                (key === 46 || key === 8) &&
                document.querySelectorAll('textarea:focus, input:focus')
                    .length === 0
            ) {
                fabricCanvas?.getActiveObjects().forEach((obj) => {
                    if (!obj.identifier) {
                        fabricCanvas.remove(obj)
                    }
                })

                fabricCanvas?.discardActiveObject().requestRenderAll()
                fabricCanvas.calcOffset()
                fabricCanvas.fire('object:modified')
            }
        })

        // line drawing
        lineDrawing(fabricCanvas, fabric)

        LineShape(fabricCanvas, fabric)

        NarrowPointerShape(fabricCanvas, fabric)

        BlockLineShape(fabricCanvas, fabric)

        // line Arrow drawing
        lineArrow(fabricCanvas, fabric)

        //end Caps line drawing
        endCapsLine(fabricCanvas, fabric)

        //line Arrow drawing for testing

        lineArrowTwo(fabricCanvas, fabric)

        //line Left Right Arrow drawing for testing

        lineArrowLeftRight(fabricCanvas, fabric)

        //Rectangle drawing

        rectangleDrawing(fabricCanvas, fabric)

        //Triangle drawing
        triangleDrawing(fabricCanvas, fabric)

        //Circle drawing
        circleDrawing(fabricCanvas, fabric)
        //3 sided Rectangle drawing
        rectangle3SidedDrawing(fabricCanvas, fabric)

        // path drawing
        pathDrawing(fabricCanvas, fabric)

        // two point curve marker drawing
        markerDrawing(
            fabricCanvas,
            fabric,
            props.setIsMarkToolRelease,
            props.setCommentCanvasId,
            props.setCommentPositionNumber
        )

        // Single point marker
        // SinglePointMark(
        //     fabricCanvas,
        //     fabric,
        //     props.setIsMarkToolRelease,
        //     props.setCommentCanvasId,
        //     props.setCommentPositionNumber
        // )

        CommentShape(
            fabricCanvas,
            props.setIsMarkToolRelease,
            props.setCommentCanvasId,
            props.setCommentPositionNumber
        )

        // text drawing
        textBoxDrawing(fabricCanvas, fabric, props.setActiveTool)

        // add demo objects
        demoContent(fabricCanvas, fabric, props.canvasImages)

        // save history's first state on startup
        if (!props.listOfCanvasData[props.idName]) {
            setTimeout(() => {
                const states = []
                states.push(fabricCanvas.toJSON())
                props.setHistory({
                    index: 0,
                    states: states
                })
                setNewCanvas(fabricCanvas)
                props.setCanvas(fabricCanvas, props.idName)
            }, 1000)
        } else {
            setNewCanvas(fabricCanvas)
            props.setCanvas(fabricCanvas, props.idName)
        }

        return () => {
            document.removeEventListener('keydown', keyDownListener)
        }
    }, [props])

    useEffect(() => {
        if (newCanvas === undefined) return
        const value = getZoomRatio()
        props.setZoom(value)
        applyZoom(newCanvas, value)
    }, [newCanvas])

    const resetCanvas = () => {
        props.setCanvas(newCanvas, props.idName)
    }

    const changeCanvasName = async (e) => {
        await props.changeCanvasName(e.target.value, props.idName)
    }
    //For paste data
    // useEffect(() => {
    //     const element = document.getElementById(`parent_${props.idName}`)
    //     element.addEventListener('paste', handlePaste)
    //     console.log('copyDataRef-handlePaste:', copyDataRef)

    //     return () => {
    //         element.removeEventListener('paste', handlePaste)
    //     }
    // }, [])
    // const handlePaste = (e) => {
    //    // e.preventDefault()
    //     console.log('copyDataRef-handlePaste:', copyDataRef)
    // }

    useEffect(() => {
        const element = document.getElementById(`parent_${props.idName}`)
        element.addEventListener('drop', handleDrop)

        return () => {
            element.removeEventListener('drop', handleDrop)
        }
    }, [])

    const processFiles = (files) => {
        const allowedTypes = ['image/jpeg', 'image/png']
        const droppedImage = []
        const newFiles = []
        for (const file of files) {
            if (!allowedTypes.includes(file.type)) continue
            const d1 = new Date()
            file.uId = d1.getTime() + Math.round(Math.random() * 1000000)
            file.fileType = 'REFERENCE_IMAGE'
            newFiles.push(file)
            droppedImage.push(file)
        }

        if (props.uploadDocument && newFiles.length > 0) {
            props.uploadDocument(newFiles)
        }
        props.setDroppedImage(droppedImage)
        props.setActiveTool('upload')
    }

    const handleDrop = (e) => {
        e.preventDefault()
        processFiles(e.dataTransfer.files)
        e.target.value = null
    }

    const handleDelete = () => {
        props.removeCanvas(props.idName)
    }

    const canvasTitle = () => {
        return (
            <div className='canvas-info'>
                <div className='title'>
                    <input
                        id={`title_${props.idName}`}
                        type='text'
                        value={canvasNameRef.current.toString()}
                        name='canvasName'
                        onChange={changeCanvasName}
                    />
                    {/* {props.idName !== 'canvasId1' && ( */}
                    <span id={'delete_' + props.idName}>
                        <IconDelete />
                    </span>
                    {/* )} */}
                </div>
                <div className='undo-redo-icons'>
                    <span
                        title='Undo'
                        className='undo'
                        id={'undo_' + props.idName}
                    >
                        <UndoIcon />
                    </span>
                    <span
                        title='Redo'
                        className='redo'
                        id={'redo_' + props.idName}
                    >
                        <RedoIcon />
                    </span>
                </div>
            </div>
        )
    }

    useEffect(() => {
        const element = document
            .getElementById(`parent_${props.idName}`)
            ?.querySelector('.canvas-container')
        const html = ReactDOMServer.renderToString(canvasTitle())
        const parser = new DOMParser()
        const doc = parser.parseFromString(html, 'text/html')
        if (element && doc.body.children.length > 0) {
            if (doc.body.children[0]) {
                element.prepend(doc.body.children[0])
            }
        }
    }, [props.idName])

    useEffect(() => {
        const elementTitle = document.getElementById('title_' + props.idName)
        const elementRedo = document.getElementById('redo_' + props.idName)
        const elementDelete = document.getElementById('delete_' + props.idName)
        const elementUndo = document.getElementById('undo_' + props.idName)
        const element = document
            .getElementById(`parent_${props.idName}`)
            ?.querySelector('.canvas-container')

        elementTitle?.addEventListener('change', changeCanvasName)
        elementRedo?.addEventListener('click', props.handleRedo)
        elementDelete?.addEventListener('click', handleDelete)
        elementUndo?.addEventListener('click', props.handleUndo)
        element?.addEventListener('mouseover', resetCanvas)
        element?.addEventListener('touchend', resetCanvas)

        return () => {
            elementTitle?.removeEventListener('change', changeCanvasName)
            elementRedo?.removeEventListener('click', props.handleRedo)
            elementUndo?.removeEventListener('click', props.handleUndo)
            elementDelete?.removeEventListener('click', handleDelete)
            element?.removeEventListener('mouseover', resetCanvas)
            element?.removeEventListener('touchend', resetCanvas)
        }
    }, [props])

    return (
        <div
            id={`holder_${props.idName}`}
            className='canvas-wrapper'
            key={`fabric_canvas_${props.idName}`}
        >
            <div className='canvas-holder'>
                <div
                    id={`parent_${props.idName}`}
                    className={
                        props.activeCanvasId === props.idName
                            ? 'canvas-parent active-canvas'
                            : 'canvas-parent'
                    }
                >
                    <canvas
                        id={props.idName}
                        key={`fabric_main_canvas_${props.idName}`}
                    />
                    {props.isMarkToolRelease && (
                        <CommentPopUp
                            idName={props.idName}
                            memberList={props.memberList}
                            addNewPost={props.addNewPost}
                            canvas={props.canvas}
                            onHide={props.onHide}
                            userInfo={props.userInfo}
                            commentCanvasId={props.commentCanvasId}
                            listOfComments={props.listOfComments}
                            commentPositionNumber={props.commentPositionNumber}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

export default FabricCanvas
